export const BEFORE = 'BEFORE';
export const AFTER = 'AFTER';